import { availableFirst, withSearchLoading } from '~/lib/search';

const attachActiveSchedules = (results) => (results ?? []).map((result) => ({
  ...result,
  activeSchedule: result.applicableSchedule
    ? result.lot?.parkingSchedules?.find((schedule) => schedule.id === result.applicableSchedule)
    : null,
}));

export const useSearch = async (id, checkInDate, checkOutDate, byFacility = true, airport = '') => {
  const facilitySearch = useFacilitySearch();
  const params = new URLSearchParams({ checkinDate: checkInDate || '' });
  if (checkOutDate) params.set('checkoutDate', checkOutDate);
  if (airport) params.set('airport', airport);
  else if (byFacility && id && id !== 'all') params.set('facility', id);
  else if (!byFacility && id && id !== 'all') params.set('collection', id);

  const { data, error } = await withSearchLoading(facilitySearch, () => useApiV3().get(`/search?${params}`));
  if (error) {
    console.error('Search failed:', error);
    return { isLoading: false, error, results: [] };
  }
  const results = attachActiveSchedules(data);
  facilitySearch.setSearchResults(availableFirst(results));
  return { isLoading: false, error: null, results };
};
